import { InMemoryCache, type PossibleTypesMap, type TypePolicies } from '@apollo/client';

const typePolicies: TypePolicies = {
  Query: {
    fields: {
      restricted: {
        merge: true,
      },
      admin: {
        merge: true,
      },
      earningsGraph: {
        keyArgs: ['productId', 'year', 'subType', 'source', 'universityId'],
      },
      userFeedbacksGraph: {
        keyArgs: ['productId', 'year'],
      },
    },
  },
  JobRecord: {
    fields: {
      metricsSummary: {
        keyArgs: false,
        merge(existing = {}, incoming, { variables }) {
          const attemptType = variables?.filter?.attemptType;
          return {
            ...existing,
            [attemptType]: incoming,
          };
        },
        read(existing, { variables }) {
          const attemptType = variables?.filter?.attemptType;
          return existing?.[attemptType] || null;
        },
      },
    },
  },
  Stats: {
    keyFields: ['id', 'name'],
  },
  Picture: {
    keyFields: (object) => (object.typeId != null ? ['id', 'typeId'] : ['id']),
  },
};

/**
 * REF:- https://www.apollographql.com/docs/react/data/fragments/#defining-possibletypes-manually
 * https://github.com/apollographql/apollo-client/issues/9904
 */
const possibleTypes: PossibleTypesMap = {
  Question: [
    'QuestionPrescription',
    'QuestionSelect3',
    'QuestionEMQ',
    'QuestionRanking',
    'QuestionMultiA',
    'QuestionQA',
    'QuestionSBA',
  ],
  PrescriptionType: ['Dose', 'Drug', 'Route', 'Duration', 'Frequency', 'Unit'],
};

export const cache = new InMemoryCache({
  typePolicies,
  possibleTypes,
});
